export enum VehicleStatusenum {
    OCCUPIED = 'OCCUPIED',
    NOT_OCCUPIED = 'NOT OCCUPIED',
    MAINTAINANCE='MAINTAINANCE',
    
  }

  export enum VehicleTypeEnum {
    INHOUSE = 'In House',
    VENDOR = 'Vendor',
    
  }

  export enum FuleTypeEnum {
    PETROL = 'Petrol',
    DIESEL = 'Diesel',
    
  }

  export enum FuleMeasuredInEnum {
    LITRES = 'Litres',
    GALLONS = 'Gallons',
    
  }  